import { OperatorPanelWrapper, OperatorPanelWrapperFullSize } from '../../../components/Layout'
import { IAHU_Optimizer } from './types'
import { Block } from 'baseui/block';
import { ValueDisplay, ValueDisplayWithLabel } from '../../../components/ValueDisplay';
import { themedUseStyletron } from '../../../../theme/customTheme';
import { TimeSeriesLineChart } from '../../../../features/Charts/LineCharts/TimeSeriesLineChart';

export const OperatorPanel = (props: IAHU_Optimizer) => {
    const [css, theme] = themedUseStyletron();
    return (


        <OperatorPanelWrapperFullSize objectId={props.id} resourceGroupId={props.resourceGroupId}
        statusContent={<ValueDisplayWithLabel value={props.output} dimension='Pa' label={'calculated Setpoint'} ></ValueDisplayWithLabel>}
        additionalContent={
            <div className={css({minHeight: '300px', height: '400px',  width: '100%'})}>
              <TimeSeriesLineChart lines={[{
                    label: `calculated Setpoint`,
                    lineColor: theme.appColors.aggregate.setpoint,
                    objectId: props.id,
                    resourceGroupId: props.resourceGroupId, 
                    propertyName: 'output',
                    currentValue: props.output,
                    showPoints: false,
                    fill: true,
                },
                {
                    label: `Actual Temp`,
                    lineColor: theme.appColors.measurments.temperature,
                    objectId: props.id,
                    resourceGroupId: props.resourceGroupId, 
                    propertyName: 'actTemp',
                    currentValue: props.actTemp,
                    showPoints: false,
                    fill: false,
                    yScaleId: 'y1',
                },
                {
                    label: `Actual Airquality`,
                    lineColor: theme.appColors.measurments.airVolume,
                    objectId: props.id,
                    resourceGroupId: props.resourceGroupId, 
                    propertyName: 'actAQ',
                    currentValue: props.actAQ,
                    showPoints: false,
                    fill: false,
                    yScaleId: 'y2',
                }]}
            summarizeBy={'1s'}
            showLegend
            enableZoom
            timespan={24 * 60}></TimeSeriesLineChart>

            </div>}>
            </OperatorPanelWrapperFullSize>
    )
}

